import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import FaveButton from '../../../../../FaveButton';
import FavingIcon from '../../../../../FaveButton/FavingIcon';
import s from './FaveControl.scss';
var FaveControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, textClassName = _a.textClassName;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var isFavouritable = useDeviationAttributes(deviation, isOwner).isFavouritable;
    var renderFaveButtonContent = function (_a) {
        var isFavourite = _a.isFavourite, faveCount = _a.faveCount;
        if (isMobile) {
            return (React.createElement(ThumbIconButton, { type: "fave", statValue: faveCount, isEngaged: isFavourite }));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(FavingIcon, { className: iconClassName, deviationId: deviation.deviationId, isFavourited: isFavourite, size: IconSize.MEDIUM, withPadding: false, disableDefaultColors: true, "aria-label": t('deviationview.overlay.a11y.favourite') }),
                React.createElement("span", { className: textClassName }, t(isFavourite
                    ? 'actionbar.inFavourites'
                    : 'actionbar.addToFavourites'))));
        }
    };
    return isFavouritable ? (React.createElement(FaveButton, { className: classnames(s['root'], className), deviation: deviation, "aria-label": t('deviationview.overlay.a11y.favourite') }, renderFaveButtonContent)) : null;
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
//# sourceMappingURL=FaveControl.js.map